import { Component, OnInit, Input } from '@angular/core';

import { MenuService } from '../../../../services/menu.service';
import { DataIoService } from '../../../../services/data-io.service';
import { MenuNode } from '../../../../classes';

@Component({
  selector: 'screen-loadinganimation',
  templateUrl: './loadinganimation.component.html',
  styleUrls: ['./loadinganimation.component.scss']
})
export class LoadinganimationComponent implements OnInit {
	@Input('debug') debug: boolean = false;
	@Input('mode') mode :string = "setup";


	texts = new Array<string>();
	title="";
	dashIcon:string="iconGreenIQ";
	constructor(private menuService: MenuService) { 
		this.evaluateMode();
	}
	getText(idx:number):string{
		return this.menuService.getText(idx);
	}
	evaluateMode(){
		this.mode="default";
		if(this.menuService.hasParameter('setup')){
			this.mode = "setup";
		}

		switch(this.mode){
			case 'setup':{
				this.title = '';
				this.dashIcon = '';//'iconVaillant';
				this.texts.length=0;
				this.texts.push('');
				this.texts.push('');
				this.debugOut("Setup-Mode.");
				break;
			}
			default:{

				this.title = this.menuService.currentNode.getTitle();
				this.dashIcon = this.menuService.currentNode.getIcon();
			}
		}
	}
	debugOut(msg:string):void{
		if(this.debug){
			console.log("LoadinganimationComponent: "+msg);
		}
	}
	ngOnInit() {
		this.evaluateMode();
  	}

}
